import Vue from 'vue'

export const eventBus = new Vue()

// events
export const OPEN_NAVIGATION_DRAWER = 'LAYOUT::OPEN_NAVIGATION_DRAWER'
export const CLOSE_NAVIGATION_DRAWER = 'LAYOUT::CLOSE_NAVIGATION_DRAWER'

export const SNACKBAR_MESSAGE = 'LAYOUT::SNACKBAR_MESSAGE'
